var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#44C0FF",
    d: "M2 0h8.552v5.574a2 2 0 0 0 2 2H18V18.92a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.206 12.565c-.47 0-.84.167-1.11.5-.27.334-.405.795-.405 1.382 0 .615.13 1.08.39 1.396.259.315.634.473 1.125.473.213 0 .419-.021.618-.064.198-.042.405-.096.62-.163v.703a3.762 3.762 0 0 1-1.337.223c-.734 0-1.297-.222-1.69-.667-.393-.444-.59-1.08-.59-1.908 0-.52.096-.977.286-1.367.191-.391.467-.69.828-.899.361-.208.785-.312 1.272-.312.512 0 .985.108 1.42.323l-.295.682c-.17-.08-.348-.15-.537-.211a1.933 1.933 0 0 0-.595-.09zm5.076 3.02c0 .446-.16.796-.483 1.05-.322.253-.767.38-1.334.38-.566 0-1.03-.088-1.391-.264v-.775c.228.108.47.192.728.254.257.062.497.093.718.093.325 0 .564-.062.719-.186a.604.604 0 0 0 .231-.497.623.623 0 0 0-.213-.476c-.141-.13-.434-.285-.877-.463-.457-.185-.78-.397-.967-.634a1.342 1.342 0 0 1-.281-.857c0-.419.148-.748.446-.988.297-.24.695-.36 1.196-.36.48 0 .958.105 1.433.316l-.26.668c-.446-.187-.844-.28-1.194-.28-.265 0-.466.057-.603.172a.569.569 0 0 0-.206.458c0 .13.028.242.083.334a.84.84 0 0 0 .27.262c.126.083.352.191.68.326.367.153.637.296.808.429.172.132.298.282.378.449.08.167.12.363.12.59zm3.695-3.65h.85l-1.755 5.012h-.864l-1.749-5.013h.844l1.045 3.117c.055.148.114.34.175.574.062.234.102.408.12.523.03-.174.076-.375.137-.604.062-.228.112-.397.151-.507l1.046-3.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80959D",
    d: "M12.1.669v5.338h5.345z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/csv-icon.aef15190335ad9de652b4602e1e9bb7e.svg";
export { ForwardRef as ReactComponent };